import React, {useEffect, useMemo, useState} from 'react';
import Currency from "../Utils/Number/Currency";
import DateFormated from "../Utils/Date/Date";
import {useTranslation} from "react-i18next";
import CheckedTable from "./CheckedTable";
import Sorter from "../UI/Toolbar/Sorter";

const ByAccount = (props) => {
    const {t, i18n} = useTranslation();
    const [checked, setChecked] = useState([]);
    const [isSelectAll, setIsSelectAll] = useState(false);
    const [sortTableField, setSortTableField] = useState('lastStatementDueDate');
    const [sortTableDirection, setSortTableDirection] = useState('ASC');
    let allInvoicesGrouped = props.allInvoicesGrouped;
    let onlySubAccountCodeForInvoices = allInvoicesGrouped.map(item=>item.subAccountCode);

    useEffect(() =>
            isSelectAll
                ? setChecked(props.subAccounts.map((account) => account.subAccountCode))
                : setChecked([]),
        [isSelectAll]
    );

    const totalBySubAccount = (subAccountCode) => {
        let indexInvoice = allInvoicesGrouped.findIndex(x => x.subAccountCode === subAccountCode);
        let indexSubAccount = props.subAccounts.findIndex(x => x.subAccountCode === subAccountCode);
        let total = 0.00;
        allInvoicesGrouped[indexInvoice].items.map((item)=> {
            if (["K","H"].includes(props.subAccounts[indexSubAccount].subAccountDisplayMode.code) && item.statementDate === null)
                total += 0.00;
            else total += item.balanceAmount.value;
        });
        return total;
    }

    useEffect(() => {
            if(checked.length !== 0){
                let total = 0;

                let theSelection = props.subAccounts.filter((thisChecked) => checked.includes(thisChecked.subAccountCode));
                /*
                theSelection.map((item)=> {
                    total += ((["K","H"].includes(item.subAccountDisplayMode.code))?item.lastStatementBalance.value:item.totalBalance.value);
                });
                */

                theSelection.map((item)=> {
                    total += totalBySubAccount(item.subAccountCode);
                });

                total = total.toFixed(2);

                let min = Math.max(...theSelection.map((item) => {
                            if (item.minimumOnlinePaymentCreditCard > item.minimumOnlinePaymentEFT) {
                                return item.minimumOnlinePaymentEFT
                            }
                            return item.minimumOnlinePaymentCreditCard
                    }
                ));

                let max = Math.min(...theSelection.map((item) => {
                            if (item.maximumOnlinePaymentCreditCard < item.maximumOnlinePaymentEFT) {
                                return item.maximumOnlinePaymentEFT
                            }
                            return item.maximumOnlinePaymentCreditCard
                    }
                ));

                let array = {
                    total : total,
                    selection : theSelection,
                    min : min,
                    max : max,
                }
                props.handleBySubAccount(array);
            }else{
                props.handleBySubAccount({ total : 0 });
            }
        },
        [checked]
    );

    useEffect(() => {
        if(props.locationState.state && props.locationState.state.selection ){
            setChecked([props.locationState.state.selection[0]]);
            props.locationState.state = undefined; // One timer
        }
    },[]);

    const setSorterCallback = (columnId, direction) => {
        setSortTableField(columnId)
        setSortTableDirection(direction)
    }

    const handleCheck = (isChecked, value) => {
        if (isChecked && !checked.includes(value)) {
            setChecked((checked) => [
                ...checked.filter((thisChecked) => thisChecked !== value),
                value,
            ]);
        } else {
            setChecked((checked) =>
                checked.filter((thisChecked) => thisChecked !== value)
            );
        }
    };

    const handleSort = (sortBy) => {
        if (sortBy.length > 0) {
            const isDESC = sortTableDirection === 'DESC'
            if (sortTableField !== sortBy[0].id || isDESC !== sortBy[0].desc) {
                setSortTableDirection(sortBy[0].desc ? 'DESC' : 'ASC');
                setSortTableField(sortBy[0].id)
            }
        }
    }

    const columns = useMemo(
        () => [
            {
                Header: (
                    <div className="form-check flex flex-row justify-content-end align-items-end">
                        <input
                            type="checkbox"
                            id="select_all"
                            className="form-check-input"
                            value={isSelectAll}
                            onChange={(v) => setIsSelectAll(v.target.checked)}
                        />
                    </div>
                ),
                accessor: "checkBox",
                disableSortBy: true,
                options:{},
                Cell: (props) => {
                    return (
                        <div className="form-check flex flex-row justify-content-end">
                            <input
                                type="checkbox"
                                value={props.row.original.subAccountCode}
                                className="form-check-input"
                                onChange={(v) => {
                                    handleCheck(
                                        v.target.checked,
                                        v.target.value
                                    );
                                }}
                                checked={!!checked.includes(props.row.original.subAccountCode)}
                            />
                        </div>
                    );
                }
            },
           {
               Header: t("docs.invoices.table.headers.accountbilled"),
                accessor: 'subAccountName',
                Cell: (props) => {
                    return props.value ? (
                        <React.Fragment>
                            <strong>{props.value}</strong>
                            <br />
                            <small>
                                {Object.values(props.row.original.address)
                                    .filter((el) => {
                                        return el != null && el !== "";
                                    })
                                    .join(", ")}
                            </small>
                        </React.Fragment>

                    ) : '';
                },
            },
            {
                Header: t('dashboard.subaccounts.table.header.code'),
                accessor: 'subAccountCode',
                Cell: (props) => {
                    return props.value ? props.value : '';
                }
            },
            {
                Header: t('dashboard.subaccounts.table.header.subaccount_type'),
                id: 'subAccountType',
                accessor: 'subAccountType',
                sortType: (
                    (rowA, rowB, columnId) => {
                        const a = rowA.values[columnId].code;
                        const b = rowB.values[columnId].code;
                        return a > b ? 1 : -1;
                    }
                ),
                Cell: (props) => {
                    let descriptionAccessor = 'descriptionEn';
                    if (i18n.language === 'fr') descriptionAccessor = 'descriptionFr';
                    return props.value[descriptionAccessor] ? props.value[descriptionAccessor] : '';
                },
            },{
                id: "lastStatementDueDate",
                Header: t("docs.invoices.table.headers.payment_due_date"),
                accessor: "lastStatementDueDate",
                sort: "desc",
                Cell: (props) => {
                    if (props.value) {
                        return (
                            <DateFormated date={props.value} withTime={false} />
                        );
                    } else {
                        return "";
                    }
                },
                sortMethod: (a, b) => {
                    var a1 = new Date(a).getTime();
                    var b1 = new Date(b).getTime();
                    if (a1 < b1) return 1;
                    else if (a1 > b1) return -1;
                    else return 0;
                },
            },
            {
                id: "totalBalance",
                Header: t('dashboard.subaccounts.table.header.balancedue'),
                accessor: (a) => {
                    return totalBySubAccount(a.subAccountCode);
                },
                sortType: (
                    (rowA, rowB, columnId) => {
                        const a = parseFloat(rowA.values[columnId].value.toFixed(2));
                        const b = parseFloat(rowB.values[columnId].value.toFixed(2));
                        return a > b ? 1 : -1;
                    }
                ),
                Cell: (props) => {
                    return props.value ? <Currency value={props.value}/> : '';
                }
            },

        ],
        [t, i18n, checked]
    );

    const setSortByCallback = useMemo(() =>
            [{desc:sortTableDirection==='DESC', id:sortTableField}]
        , [sortTableDirection, sortTableField])

    let sorterValues = [
      {
            label: t("docs.invoices.table.headers.accountbilled"),
            id: 'subAccountName',
            value: 'subAccountName',
            type: 'string'
        },{
            label: t("docs.invoices.table.headers.code"),
            id: 'subAccountCode',
            value: 'subAccountCode',
            type: 'int'
        },{
            label: t('profile.account_type'),
            id: 'subAccountType',
            value: (i18n.language === 'fr') ? 'subAccountType.descriptionFr' : 'subAccountType.descriptionEn',
            type: 'string'
        },{
            label: t("docs.invoices.table.headers.due_date"),
            id: 'lastStatementDueDate',
            value: '-lastStatementDueDate',
            type: 'date'
        },{
            label: t('dashboard.subaccounts.table.header.balancedue'),
            id: 'totalBalance',
            value: 'totalBalance.value',
            type: 'float'
        }
    ];


    return (
        <React.Fragment>

            <div className="d-flex justify-content-end payment-toolbar">
                <Sorter
                    sortOptions={sorterValues}
                    items={props.subAccounts}
                    getSortedItems={props.subAccounts}
                    setSortByCallback={setSorterCallback}
                    sortDirection={sortTableDirection}
                    sortField={sortTableField}
                    currentDisplayMode='list'
                />
            </div>
                <CheckedTable
                    onSort={handleSort}
                    initialStateField={sortTableField}
                    initialStateDirection={sortTableDirection}
                    columns={columns}
                    hideExport={true}
                    data={props.subAccounts}
                    checked={checked}
                    setSortByCallback={setSortByCallback}
                />
        </React.Fragment>
    )
};

export default ByAccount;
